import * as React from 'react';
import { useSelector } from 'react-redux';
import { Button, useDeviceType } from '@cian/ui-kit';
import { Controls } from '../../components/LandingPageV2/Controls';
import { FORM_ANCHOR } from '../../constants/requestForm';
import { useAppDispatch } from '../../hooks/useAppDispatch';
import { selectConsultantPhone } from '../../selectors/consultantContacts';
import { selectFlightEnabled } from '../../selectors/meta';
import { selectQuizItemByType } from '../../selectors/quizItems';
import { setAnimationAvailable, setIsContactsModalOpen } from '../../slices';
import { trackKpnCallClick } from '../../utils/analytics';
import { trackKpnSurveyButtonClick } from '../../utils/analytics/trackKpnSurveyButtonClick';

interface IContactsControlsProps {
  placement: 'header' | 'bottomFloat';
  phoneDataTestId: string;
  requestFormDataTestId: string;
}

export const ContactsControls = ({
  placement,
  phoneDataTestId,
  requestFormDataTestId,
}: IContactsControlsProps): React.JSX.Element => {
  const deviceType = useDeviceType();
  const isDesktop = deviceType === 'desktop';
  const buttonSize = isDesktop ? 'L' : 'M';
  const phone = useSelector(selectConsultantPhone);
  const dispatch = useAppDispatch();
  const isFlightEnabled = useSelector(selectFlightEnabled);
  // Деградация если ручка квиза ответила 500, то не показываем форму
  const quizItem = useSelector(selectQuizItemByType('rooms')); // const isAnimationAvailable = useSelector(selectIsAnimationAvailable);

  const handleCallButtonClick = () => {
    if (isDesktop) {
      dispatch(setIsContactsModalOpen(true));
    } else {
      window.location.href = `tel:${phone}`;
    }

    trackKpnCallClick();
  };

  const handleRequestFormClick = () => {
    dispatch(setAnimationAvailable(false));
    const form = document.getElementById(FORM_ANCHOR);
    if (form) {
      form.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    trackKpnSurveyButtonClick();
  };

  return (
    <Controls maxWidth={isFlightEnabled && placement === 'header' ? 242 : 300}>
      {quizItem && (
        <Button
          data-testid={requestFormDataTestId}
          size={buttonSize}
          theme="fill_primary"
          fullWidth
          onClick={handleRequestFormClick}
        >
          Заполнить заявку
        </Button>
      )}
      <Button
        data-testid={phoneDataTestId}
        size={buttonSize}
        theme={isFlightEnabled && placement === 'header' ? 'fill_white_primary' : 'fill_secondary'}
        fullWidth
        onClick={handleCallButtonClick}
      >
        Позвонить консультанту
      </Button>
    </Controls>
  );
};
